// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__3l9w1"};